module.exports = __webpack_public_path__ + "img/windows.2b8dd344.png";